export default "__VITE_ASSET__DiWf_ZZt__"